import api from "../../http";

export default class ApiOtherGame {
  static async getApiOtherGame(url, id) {
    const params = {
      "id": id
    };
    return api.get(url, {params})
  }
}